const WasteManagementIconMenu = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_2312_11277)"
      fill-opacity="0.1"
    />
    <path
      d="M10.6002 22.2999C10.6002 23.2944 11.4057 24.0999 12.4002 24.0999H19.6002C20.5947 24.0999 21.4002 23.2944 21.4002 22.2999V11.4999H10.6002V22.2999ZM22.3002 8.7999H19.1502L18.2502 7.8999H13.7502L12.8502 8.7999H9.7002V10.5999H22.3002V8.7999Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2312_11277"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0062FF" />
        <stop offset="1" stop-color="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default WasteManagementIconMenu
